<template>
  <div class="third-pay-send p12">
    <div class="card mb12">
      <div class="head">
        <span>{{ detail.receiveName }}</span>
        发起了一笔代付请求
      </div>
      <div class="money">
        <span class="icon">￥</span>
        <span class="amount" v-if="detail.amount">{{ (detail.amount / 100).toLocaleString() }}</span>
      </div>
      <template v-if="detail.payStatus === 0">
        <div class="tips">
          剩余支付时间
          <span class="timer">
            <span class="tt van-hairline--surround">{{ timer.hh }}</span>
            <span class="mm">:</span>
            <span class="tt van-hairline--surround">{{ timer.mm }}</span>
            <span class="mm">:</span>
            <span class="tt van-hairline--surround">{{ timer.ss }}</span>
          </span>
        </div>
        <div class="sub-button van-hairline--bottom">
          <van-button type="primary" size="middle" round block @click="handleShare">立即发起代付请求</van-button>
        </div>
      </template>
      <template v-else>
        <div class="other-tip">
          <span v-if="detail.payStatus === 1">你的好友已帮你支付</span>
          <span v-if="detail.payStatus === 99">超时未支付，订单已自动取消</span>
        </div>
      </template>

      <div class="dis">
        <div class="top">代付说明：</div>
        <div class="content">
          1.选择他人代付时，可设置订单信息对方是否可见，开关打开则对方可见您要购买的商品。
          <br />
          2.如果发生退款，钱将原路退还到好友的账户内。
        </div>
      </div>
    </div>
    <div class="product">
      <div class="head flex space-between align-center">
        <div>
          代付商品
          <span>({{ detail.visibleForOther == 1 ? '关闭可向对方隐藏明细' : '打开可向对方显示明细' }})</span>
        </div>
        <div>
          <van-switch v-model="detail.visibleForOther" :active-value="1" :inactive-value="0" @change="handleChange" />
        </div>
      </div>
      <div class="">
        <goods-item v-for="(item, key) in detail.itemList" :goods="item" :key="key"></goods-item>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false" class-name="van-overlay-80">
      <div class="wrapper">
        <img :src="shareImg" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import goodsItem from '@/components/goodsItem.vue';
import shareImg from './img/img_share.png';

let timerInter;

export default {
  components: { goodsItem },
  data() {
    return {
      show: false,
      shareImg,
      orderId: '',
      detail: {
        amount: ''
      },
      timer: {
        hh: '00',
        mm: '00',
        ss: '00'
      }
    };
  },
  mounted() {
    this.init();
    wx.showOptionMenu();
  },
  beforeDestroy() {
    if (timerInter) clearTimeout(timerInter);
  },
  methods: {
    async init() {
      this.orderId = this.$route.query.orderId;
      await this.$fetch.postThirdPayPre({ orderId: this.orderId });
      this.$fetch.queryReplacePayInfo({ orderId: this.orderId }).then((res) => {
        this.detail = res;
        if (res.visibleForOther === 1) {
          wx.updateAppMessageShareData({
            title: '我急需在智云医道购买以下商品，快帮我付个款吧', // 分享标题
            desc: this.detail.itemList[0].itemName, // 分享描述
            link: window.location.origin + `/#/third-pay-share?orderId=` + this.orderId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.detail.itemList[0].mainImg || 'https://static.91jkys.com/attachment/20210415135425021_e06f9c45115047a48eba19efe2cbf6e3.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('分享设置成功');
            }
          });
        } else {
          wx.updateAppMessageShareData({
            title: '我急需在智云医道购买以下商品，快帮我付个款吧', // 分享标题
            desc: ' ', // 分享描述
            link: window.location.origin + `/#/third-pay-share?orderId=` + this.orderId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://static.91jkys.com/attachment/20210415135425021_e06f9c45115047a48eba19efe2cbf6e3.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('分享设置成功');
            }
          });
        }
        if (res.payStatus === 0) {
          this.countDown();
        }
      });
    },
    handleChange(val) {
      // itemReplacePayVisible

      this.$fetch.itemReplacePayVisible({ orderId: this.orderId, visibleFlag: val }).then((res) => {
        if (val === 1) {
          wx.updateAppMessageShareData({
            title: '我急需在智云医道购买以下商品，快帮我付个款吧', // 分享标题
            desc: this.detail.itemList[0].itemName, // 分享描述
            link: window.location.origin + `/#/third-pay-share?orderId=` + this.orderId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.detail.itemList[0].mainImg || 'https://static.91jkys.com/attachment/20210415135425021_e06f9c45115047a48eba19efe2cbf6e3.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('分享设置成功');
            }
          });
        } else {
          wx.updateAppMessageShareData({
            title: '我急需在智云医道购买以下商品，快帮我付个款吧', // 分享标题
            desc: '', // 分享描述
            link: window.location.origin + `/#/third-pay-share?orderId=` + this.orderId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://static.91jkys.com/attachment/20210415135425021_e06f9c45115047a48eba19efe2cbf6e3.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('分享设置成功');
            }
          });
        }
      });
    },
    handleShare() {
      this.show = true;
    },
    countTimeStr() {
      const endDate = dayjs(this.detail.payExpireTime);
      const d = endDate.diff(dayjs(), 'day');
      const h = endDate.diff(dayjs(), 'hour');
      const m = endDate.diff(dayjs(), 'minute');
      const s = endDate.diff(dayjs(), 'second');

      const hh = h - d * 24;
      const mm = m - h * 60;
      const ss = s - m * 60;

      this.timer.hh = `00${hh}`.slice(-2);
      this.timer.mm = `00${mm}`.slice(-2);
      this.timer.ss = `00${ss}`.slice(-2);
    },

    countDown() {
      clearTimeout(timerInter);
      timerInter = setTimeout(() => {
        const countTime = this.detail.payExpireTime - Date.now();
        if (countTime > 0) {
          this.countDown();
        } else {
          clearTimeout(timerInter);
          this.detail.expireTime = Date.now();
          this.detail.payStatus = 99;
        }
        this.countTimeStr();
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.third-pay-send {
  .van-overlay-80 {
    background-color: rgba(0, 0, 0, 0.8) !important;
  }
  .wrapper {
    width: 100%;
    height: 220px;
    img {
      width: 100%;
      height: 220px;
    }
  }
  .card {
    background: #fff;
    padding: 16px 16px 20px;
    border-radius: 8px;
    .head {
      color: #8c8c8c;
      margin-bottom: 10px;
      span {
        color: #ff8200;
      }
    }
    .money {
      color: #262626;
      height: 72px;
      text-align: center;
      padding: 18px;
      font-weight: bold;
      .icon {
        font-size: 20px;
      }
      .amount {
        font-size: 36px;
      }
    }
    .tips {
      color: #262626;
      justify-content: center;
      align-items: center;
      display: flex;
      .timer {
        margin-left: 4px;
        display: flex;
        color: #ff4e47;
        .tt {
          font-size: 12px;
          display: flex;
          width: 22px;
          height: 18px;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          // border: 1px solid #D9D9D9;
          &.van-hairline--surround::after {
            border-radius: 4px;
          }
        }
        .mm {
          padding: 0 3px;
        }
      }
    }
    .other-tip {
      color: #262626;
      justify-content: center;
      align-items: center;
      display: flex;
      padding-bottom: 32px;
      border-bottom: 1px solid #eee;
    }
    .sub-button {
      width: 100%;
      margin-top: 26px;
      padding-bottom: 20px;
      // border-bottom: 1px solid #eee;
    }
    .dis {
      .top {
        font-weight: 400;
        color: #262626;
        line-height: 20px;
        margin-top: 20px;
      }
      .content {
        margin-top: 6px;
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
        line-height: 21px;
      }
    }
  }
  .product {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 28px;
    .head {
      // padding: 12px;
      color: #262626;
      span {
        font-size: 12px;
        color: #8c8c8c;
      }
    }
  }
}
</style>
